import { useState } from "react";
import styles from "../AddMarkerModal/AddIncidentModal.module.css";
import {garageService} from "../../../../services/guide/garage-service";
import {CreateGarage} from "../../../../types/api/guide/garage.types";
import {mapCoordinateToGeoPoint} from "../../../../utils/mapCoordinate";

interface AddGarageModalProps {
    coords: [number, number];
    onClose: () => void;
    refetchData: () => void;
}

export default function AddGarageModal({ coords, onClose, refetchData }: AddGarageModalProps) {
    const [name, setName] = useState("");

    const handleSave = async () => {
        const trimmed = name.trim();
        const garage: CreateGarage = {
            name: trimmed,
            coordinate: mapCoordinateToGeoPoint(coords)
        }
        if (!trimmed) return;
        try {
            await garageService.create(garage)
        }catch (e){
            console.log(e);
        }
        refetchData();
        onClose();
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>Добавить гараж</h3>
                    <button className={styles.modalClose} onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className={styles.modalBody}>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Координаты</div>
                        <div className={styles.modalCoords}>
                            {coords[0].toFixed(6)}, {coords[1].toFixed(6)}
                        </div>
                    </div>

                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Название</div>
                        <input
                            className={styles.modalTextarea}
                            style={{ minHeight: 0, height: 40, resize: "none" }}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Например: Гараж №1"
                        />
                    </div>
                </div>

                <div className={styles.modalFooter}>
                    <button className={styles.modalButton} onClick={onClose}>
                        Отмена
                    </button>
                    <button
                        className={`${styles.modalButton} ${styles.modalButtonPrimary}`}
                        onClick={handleSave}
                        disabled={!name.trim()}
                        style={!name.trim() ? { opacity: 0.6, cursor: "not-allowed" } : {}}
                    >
                        Сохранить
                    </button>
                </div>
            </div>
        </div>
    );
}
